import { IHouseSwap } from "../types/houseswap-type";
import api from "./auth-interceptor"

class HouseSwapService {
  getAllListings() {
    return api.get(`houseswaps/`);
  }

  listHouseSwap(houseSwapContent: IHouseSwap) {
    return api.post(`houseswaps/`, houseSwapContent);
  }

  getInfoById(listingId: string) {
    return api.get<IHouseSwap>(`houseswaps/${listingId}`);
  }

  updateHouseSwap(houseSwapId: string, houseSwapContent: IHouseSwap) {
    return api.put(`houseswaps/${houseSwapId}`, houseSwapContent);
  }

  deleteListing(houseSwapId: string) {
    return api.delete(`houseswaps/${houseSwapId}/`);
  }
}

const houseSwapService = new HouseSwapService();
export default houseSwapService;